declare const addsearch: any;

$(function() {
  console.log("scripts.ts");
  (window as any).addsearch_settings = {
    display_url: true,
    display_resultscount: true,
    display_date: true,
    display_sortby: true
  };

  $("#query").keyup(function(e) {
    e.preventDefault();
    if(e.which == 13) {
      search();
    }
  });

  $("#queryResults").keyup(function(e) {
    e.preventDefault();
    if(e.which == 13) {
      searchResultPage();
    }
  });  

  $("#queryMobile").keyup(function(e) {
    e.preventDefault();

    if(e.which == 13) {
      searchMobile();
    }
  });

  $("#submitSearch").click(function() {
    search();
  });

  $("#submitSearchMobile").click(function() {
    searchMobile();
  });

  // Listens to enter key on result page and execute the search
  // Prevent submit of DNN Form so the page doesn't reload
  $("#Form").submit(function(e: any) {
    e.preventDefault();
    // addsearch.submit();
    return false;
  });

  function search() {
    var jQs = $("#query").val();
    var resultPage = $(".app-add-search-desktop").data("resultpage");
    location.href = resultPage + "?addsearch=" + jQs;
  }

  function searchMobile() {
    var jQsM = $("#queryMobile").val();
    var resultPage = $(".app-add-search-mobile").data("resultpage");
    location.href = resultPage + "?addsearch=" + jQsM;
  }

  function searchResultPage() {
    console.log("searchResultPage")
    var jQs = $("#queryResults");
    var jQsVal = $("#queryResults").val();
    var resultPage = jQs.data("resultpage");
    location.href = resultPage + "?addsearch=" + jQsVal;
  }  

});
